<!--
 * @Author: 范朝阳
 * @Date: 2020-05-09 14:01:16
 * @LastEditTime: 2020-05-09 14:23:52
 * @LastEditors: Please set LastEditors
 * @Description: 默认模板
 * @FilePath: /um-hesheng-web/src/components/UmPrint/template/json.vue
 -->
<template>
  <div style="font-family:'SimHei';font-size:12px;line-height: 1.1">
    <table
      style="
        border-collapse: collapse;
        width: 100%;
        font-size: 12px;
        border:1px;"
    >
      <caption style="font-size:14px;">打印标题</caption>
      <thead>
        <tr>
          <th
            v-for="(item,index) in printData[0]"
            :key="index"
            style="padding: 2px;border: 1px solid #333;text-align: center;"
          >{{ index }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in printData" :key="index">
          <td
            v-for="(item2,index2) in item"
            :key="index2"
            style="padding: 2px;border: 1px solid #333;text-align: center;"
          >{{ item2 }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Json',
  model: {},
  props: {
    printData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  watch: {},
  created() {},
  methods: {}
}
</script>

<style scoped>
</style>
